
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommonModule } from '@angular/common';
import { DatepickerDayComponent } from './datepicker-day/datepicker-day.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { NgModule } from '@angular/core';
import {DirectivesModule} from "maps-angular-components";

@NgModule({
  declarations: [
    DatepickerDayComponent
  ],
  imports: [
    CommonModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatInputModule,
    DirectivesModule
  ],
  exports: [
    DatepickerDayComponent
  ]
})
export class DatepickerEnquadramentoModule { }
